import m from "mithril";
import { Portal } from "./components/Portal";

m.mount(document.body, Portal);
